import { Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage } from "@/contexts/LanguageContext";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const LanguageSelector = () => {
  const { language, setLanguage, t } = useLanguage();

  const toggleLanguage = (newLanguage: string) => {
    setLanguage(newLanguage);
  };

  return (
    <DropdownMenu>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="text-foreground bg-background border border-border hover:bg-accent opacity-100 visible">
                <Languages className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent>
            <p>{t("language")}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <DropdownMenuContent 
        align="end" 
        className="w-48 max-h-80 overflow-y-auto bg-background border border-border shadow-lg z-[70]"
        sideOffset={5}
      >
        <DropdownMenuItem 
          onClick={() => toggleLanguage("en")}
          className={`cursor-pointer ${language === "en" ? "bg-blue-50 dark:bg-blue-900/20" : ""}`}
        >
          <span className="text-sm">🇺🇸 English</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => toggleLanguage("el")}
          className={`cursor-pointer ${language === "el" ? "bg-blue-50 dark:bg-blue-900/20" : ""}`}
        >
          <span className="text-sm">🇬🇷 Ελληνικά</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => toggleLanguage("fr")}
          className={`cursor-pointer ${language === "fr" ? "bg-blue-50 dark:bg-blue-900/20" : ""}`}
        >
          <span className="text-sm">🇫🇷 Français</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};